import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import { Row, Col, Card, CardBody, Button, Container } from "reactstrap";
import Header from "../../layout/Header/Header";

function ProviderDashboard() {
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleAccessGenerator = () => {
        navigate('/china-label-generator');
    };
    
    return (
        <>
            <Header />
            <Container fluid className="mt-4">
                <Row>
                    <Col md={12}>
                        <h3 className="mb-4">Welcome, {user.nombre_comercial}</h3>
                    </Col>
                </Row>
                
                <Row className="justify-content-center">
                    <Col md={6} lg={4}>
                        <Card className="shadow-sm">
                            <CardBody className="text-center p-4">
                                <div className="mb-3">
                                    <i className="fas fa-tags fa-3x text-primary"></i>
                                </div>
                                <h5 className="card-title">China Label Generator</h5>
                                <p className="card-text text-muted">
                                    Generate labels for your products with custom quantities by color and size.
                                </p>
                                <Button
                                    color="primary"
                                    size="lg"
                                    onClick={handleAccessGenerator}
                                    className="mt-3"
                                >
                                    <i className="fas fa-arrow-right me-2"></i>
                                    Access Generator
                                </Button>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                
                <Row className="justify-content-center mt-4">
                    <Col md={8}>
                        <Card className="border-0 bg-light">
                            <CardBody className="text-center">
                                <h6 className="text-muted mb-0">
                                    <i className="fas fa-info-circle me-2"></i>
                                    You have access to the China Label Generator. Contact support if you need additional permissions.
                                </h6>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default ProviderDashboard;